import { ChangeUserAvatarCtrl } from "@gtmhub/users/controllers/change-user-avatar";
import { IComponentOptions } from "angular";

//This component is using the logic of another controller, however I will refactor ChangeUserAvatarCtrl soon to work like component
export const ChangeUserPictureComponent: IComponentOptions = {
  controller: ChangeUserAvatarCtrl,
  templateUrl: require("./change-user-picture.component.jade"),
};
